import axios from 'axios';

// Base URL for the Deepsage service
const wsUrl = "https://deep-sage.softmining.it/ws.php";

/**
 * Invia la richiesta Deepsage.
 * Il payload include il serviceName "ENQUEUE_DEEPSAGE_REQUEST_JSON", l'IDD e il JSON in stringa.
 */
export const enqueueDeepsageRequest = async (IDD, Graph, filename) => {
    try {
        const response = await axios.post(
            wsUrl,
            {
                serviceName: "ENQUEUE_DEEPSAGE_REQUEST_JSON",
                IDD,
                Graph,
                GID: filename
            },
            {
                headers: { "Content-Type": "application/json" }
            }
        );
        console.log("1 step:" + response.data.output);
        console.log("1 step:" + response.data.GID);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message);
    }
};

/**
 * Controlla lo stato della richiesta Deepsage.
 */
export const checkDeepsageStatus = async (IDD, GID) => {
    try {
        const response = await axios.post(
            wsUrl,
            {
                serviceName: "DEEPSAGE_REQUEST_STATUS",
                IDD,
                GID,
            },
            {
                headers: { "Content-Type": "application/json" }
            }
        );
        console.log("2 step:" + response.data.output);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message);
    }
};

/**
 * Recupera l'output elaborato da Deepsage (in formato markdown).
 */
export const getDeepsageOutput = async (IDD, GID) => {
    try {
        const response = await axios.post(
            wsUrl,
            {
                serviceName: "GET_DEEPSAGE_OUTPUT",
                IDD,
                GID,
            },
            {
                headers: { "Content-Type": "application/json" }
            }
        );
        console.log("3 step:" + response.data.output);
        return response.data;
    } catch (error) {
        throw new Error(error.response?.data?.error || error.message);
    }
};
